import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as S from './styles';

export default function TableLegend({ data, ...rest }) {
  const { t } = useTranslation();
  return (
    <S.LegendContainer {...rest}>
      {data.map(({ property }) => {
        return (
          <S.Item key={property}>
            <S.Title>{t(`${property}Abv`)}</S.Title>:
            <S.Description>{t(property)}</S.Description>
          </S.Item>
        );
      })}
    </S.LegendContainer>
  );
}

TableLegend.propTypes = {
  data: PropTypes.array,
};

TableLegend.defaultProps = {
  data: [],
};
